export const IBaseScreenViewModelType = Symbol('IBaseScreenViewModel');
